import {
  IWatercraftType,
  WatercraftTypeActions,
  WatercraftTypeState,
  WatercraftTypeMutations,
  WatercraftTypeGetters
} from "./types";
import { DefineActions } from "vuex-type-helper";
import * as types from "@/store/mutation-types";
import {
  GenericCreateOne,
  GenericDeleteOne,
  GenericGetOne,
  GenericMakeRequest,
  GenericUpdateOne
} from "@/store/helpers/actions";
import WatercraftTypeService from "@/services/watercraftType.service";

export const actions: DefineActions<
  WatercraftTypeActions,
  WatercraftTypeState,
  WatercraftTypeMutations,
  WatercraftTypeGetters
> = {
  createWatercraftType: GenericCreateOne<
    WatercraftTypeState,
    WatercraftTypeGetters,
    WatercraftTypeActions,
    WatercraftTypeMutations,
    IWatercraftType
  >(WatercraftTypeService, types.SET_ITEM as any),
  async getWatercraftTypes({ commit }, payload) {
    try {
      commit(types.SET_STATES, { makingApiRequest: true });
      const { data } = await WatercraftTypeService.getWatercraftTypes(
        payload.query
      );
      commit(types.SET_STATES, {
        watercraftTypes: data
      });
      commit(types.SET_STATE, { key: "lastUpdate", value: new Date() });
      return data;
    } finally {
      commit(types.SET_STATES, { makingApiRequest: false });
    }
  },
  getWatercraftType: GenericGetOne<
    WatercraftTypeState,
    WatercraftTypeGetters,
    WatercraftTypeActions,
    WatercraftTypeMutations
  >(WatercraftTypeService, types.SET_ITEM as any),
  deleteWatercraftType: GenericDeleteOne<
    WatercraftTypeState,
    WatercraftTypeGetters,
    WatercraftTypeActions,
    WatercraftTypeMutations
  >(WatercraftTypeService, types.DELETE_ITEM as any),
  updateWatercraftType: GenericUpdateOne<
    WatercraftTypeState,
    WatercraftTypeGetters,
    WatercraftTypeActions,
    WatercraftTypeMutations,
    { id: string; update: Partial<IWatercraftType> }
  >(WatercraftTypeService, types.SET_ITEM as any),
  deleteWatercraftTypes: GenericMakeRequest<
    WatercraftTypeState,
    WatercraftTypeGetters,
    WatercraftTypeActions,
    WatercraftTypeMutations
  >(
    WatercraftTypeService.deleteBulkWatercraftTypes.bind(WatercraftTypeService)
  ),
  deleteBulkWatercraftTypes: async ({ commit }, watercraftTypeIds) => {
    try {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: true } as any
      );
      const response = await WatercraftTypeService.deleteBulk(
        watercraftTypeIds
      );
      return response.data;
    } finally {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: false } as any
      );
    }
  },
  restoreBulkWatercraftTypes: async ({ commit }, watercraftTypeIds) => {
    try {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: true } as any
      );
      const response = await WatercraftTypeService.restoreBulk(
        watercraftTypeIds
      );
      return response.data;
    } finally {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: false } as any
      );
    }
  }
};
